import _asyncToGenerator from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
import Gikam from 'gikam';
export default {
  props: {
    options: Object
  },
  data: function data() {
    return {
      active: false
    };
  },
  methods: {
    clickHandle: function clickHandle() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return Gikam.window.activePageEditSettingItem(_this);

              case 2:
                Gikam.window.openSettingPanel({
                  title: _this.$i18n('pageEdit.button.setting'),
                  type: 'ButtonSetting',
                  options: _this.options
                });

              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    }
  },
  computed: {
    classObject: function classObject() {
      var classList = ['button-page-edit-wrapper', {
        active: this.active
      }];
      return classList;
    }
  }
};